module.exports = __webpack_public_path__ + "img/zl.bfd08c47.png";